import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button, Spinner } from "react-bootstrap";
import "./Unidades_medida_cadastro.css";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import {
  getUnidadesMedidaById,
  getUnidadeMedidaCadastro,
  getUnidadeMedidaUpdate,
} from "../../services/api_cadastro_unidade_medida";
import Swal from "sweetalert2";

const UnidadesMedidaRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  const [descricao, setDescricao] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [isSaving, setSaving] = useState(false)

  useEffect(() => {
    const fetchUnidadesMedida = async () => {
      try {
        const response = await getUnidadesMedidaById(id);

        const unidades_medida = response.data.UnidadeMedida;
        setDescricao(unidades_medida.descricao || "");

        //console.log(response.data.UnidadeMedida);
      } catch (error) {
        console.error("Erro ao obter dados da Unidade de Medida:", error);
      }
    };

    if (id) {
      fetchUnidadesMedida();
    }
  }, [id]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const validarInputs = () => {
    if (!descricao) {
      Swal.fire({
        icon: "info",
        title: "O campo Descrição é obrigatório",
      });
      return false;
    }
    return true;
  };

  const addCadastro = async (body) => {
    try {
      const response = await getUnidadeMedidaCadastro(body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar unidade de medida:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar a unidade de medida:", error);
        handleOpenModal(
          "Erro ao atualizar a empresa",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const newUpdate = async (body) => {
    try {
      delete body.cnpj;
      delete body.inscricao_estadual;
      const response = await getUnidadeMedidaUpdate(id, body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar unidade de medida:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar a unidade de medida:", error);
        handleOpenModal(
          "Erro ao atualizar a unidade de medida",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = () => {
    if (validarInputs()) {
      setSaving(true)
      let body = {
        descricao,
      };

      if (id) {
        newUpdate(body);
      } else {
        addCadastro(body);
      }
    }
  };

  const handleCaracteres = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setDescricao(value);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O campo não pode ultrapassar 50 caracteres",
      });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSalvar();
    }
  };

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="Cadastros / Cadastro de Unidade de Medida" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        <Form className="mt-4" onKeyPress={handleKeyPress}>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group controlId="formNome">
                <Form.Label>Descrição</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Digite a descrição"
                  value={descricao}
                  onChange={handleCaracteres}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
            <Button
              className="border border-dark text-dark m-2 mt-4"
              variant="light"
              onClick={regret}
            >
              <FontAwesomeIcon icon={faWindowClose} />
            </Button>
          </div>
        </Form>
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};

export default UnidadesMedidaRegister;
